
import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { MetaProvider } from './contexts/MetaContext';
import { PorterProvider } from './contexts/PorterContext';
import appRoutes from './routes/appRoutes';

function App() {
  return (
    <AuthProvider>
      <MetaProvider>
        <PorterProvider>
          <RouterProvider router={appRoutes} />
        </PorterProvider>
      </MetaProvider>
    </AuthProvider>
  );
}

export default App;
